import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function initHeroHomeSlider() {
    // Home slider based on swiper
    const swiper = new Swiper('.hero-home-swiper', {
        slidesPerView: 1,
        loop: false,
        slideClass: 'hero-home-slide',
        autoplay: {
           delay: 5000,
        },
    });
}
